import React from 'react';

// PropTypes
import PropTypes from 'prop-types';

// Local Components
import AvatarDesign from '../FormFields/AvatarDesign';

// Typography
import { H5, Body3 } from '../../themes/typography';

// Buttons
import { PrimaryBtn } from '../Buttons/Buttons';

// CSS Styles
import '../../styles/components/EventBySection.css';

const avatarUrl =
    'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8YXZhdGFyfGVufDB8fDB8fHww';

export default function EventBySection({
    organizerName = 'Name Of The Event Creator',
    followers = 247,
    organizerAvatarUrl = avatarUrl,
    followBtn = <PrimaryBtn name="Follow" />
}) {
    return (
        <React.Fragment>
            <div className="event-by-details-container">
                {/* Event By Title */}
                <H5 fontWeight={600}>Event By</H5>

                {/* Event By Organizer Details Section*/}
                <section className="event-by-organizer-details-section">
                    <div className="organizer-details-container">
                        {/* Organizer Avatar */}
                        <AvatarDesign src={organizerAvatarUrl} />

                        {/* Organizer name and follower container */}
                        <div className="event-by-organizer-name-followers">
                            <div className="organizer-name">
                                <Body3 fontWeight={500}>{organizerName}</Body3>
                            </div>
                            <div className="organizer-followers">
                                <Body3>{followers} Followers</Body3>
                            </div>
                        </div>
                    </div>

                    {/* Follow Button Container */}
                    <div className="event-by-follow-btn">{followBtn}</div>
                </section>
            </div>
        </React.Fragment>
    );
}

// PropTypes Validation
EventBySection.propTypes = {
    organizerName: PropTypes.string.isRequired,
    followers: PropTypes.number || PropTypes.string,
    organizerAvatarUrl: PropTypes.string.isRequired,
    followBtn: PropTypes.element
};
